export default function getNftExpressDataId(mint: string) {
  return `${mint}-NftExpress`;
}
